export class Coupon {
	id: number;
	code: string;
	hour: boolean;
	discountMoney: number;
	discountPercent: number;
	minimunValueForUse: number;
	isMoneyDiscount: boolean;
	uniqueUser: boolean;
	maximumTotalUse: number;
	maximumTotalUseLeft: number;
	couponStatus: string;
	finality: string;
	onlyFirstTimeByUser: boolean;
	creationDate: number;

	toCouponFromValidate(couponValidate: CouponValidate): Coupon {
		const coupon: Coupon = new Coupon();
		coupon.code = couponValidate.couponCode;
		coupon.discountMoney = couponValidate.couponValue;
		coupon.discountPercent = couponValidate.couponPercentual;
		coupon.isMoneyDiscount = couponValidate.isMoney;
		coupon.minimunValueForUse = couponValidate.minimunValueForUse;
		coupon.finality = couponValidate.finalityType;
		coupon.maximumTotalUseLeft = couponValidate.maximumTotalUseLeft;
		return coupon;
	}
}

export class CouponValidate {
	couponCode: string;
	success: boolean;
	couponMessage: string;
	couponValue: number;
	couponPercentual: number;
	isMoney: boolean;
	minimunValueForUse: number;
	finalityType: string;
	maximumTotalUseLeft: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/coupon.model.ts